// import useLiquid from 'shared/service/use_liquid'
import { useEffect, useRef } from 'react'
import { Liquid } from 'liquidjs'
import { useSelector } from 'react-redux'

export default function useLiquid() {
  const engine = new Liquid()
  const tagOwner = useSelector(state => state.tagOwner)

  return (value, placeholders = {}) => {
      placeholders["tagOwner"] = tagOwner
      placeholders["tag_owner"] = tagOwner

      try {
        //const tpl = engine.parse(html)
        const renderedContent = engine.parseAndRenderSync(value, placeholders)
        //console.debug({renderedContent}, value, placeholders)
        //console.error({renderedContent})
        //console.error({placeholders})
        return renderedContent
      } catch (ex) {
        console.error(ex, "placeholders", placeholders, value)
      }
      return null
  }
}
